import ActionType from '../../actions/aboutPolicy/ActionType';

const initialState={
    xqtsData:[],
    policyData:[],
    policyTypeData:[],
    rdphData:[],
    zxzxData:[],
    xqts_news_data:[],
    xqts_news_detail_data:[]
}

const aboutPolicyReducer=(state=initialState,action={})=>{
    switch(action.type){
        case ActionType.FETCH_XQTS:
            return Object.assign({},state,{
                xqtsData:action.data,
            })
        case ActionType.FETCH_POLICY:
            return Object.assign({},state,{
                policyData:action.data,
            })
        case ActionType.FETCH_POLICY_TYPE:
            return Object.assign({},state,{
                policyTypeData:action.data,
            })
        case ActionType.FETCH_RDPH:
            return Object.assign({},state,{
                rdphData:action.data,
            })
        case ActionType.FETCH_ZXZX:
            return Object.assign({},state,{
                zxzxData:action.data
            })
        case ActionType.FETCH_XQTS_NEWS:
            return Object.assign({},state,{
                xqts_news_data:action.data
            })
        case ActionType.FETCH_XQTS_NEWS_DETAIL:
            return Object.assign({},state,{
                xqts_news_detail_data:action.data
            })
        default:
            return state;
    }
}

export default aboutPolicyReducer;